module.exports = "/_next/static/images/e6cc1d2a84a38cee7a98b5f04b5f3400-apply-bullet-2.jpeg.webp";